import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetMostSchaduleMinuteByPriceCategory extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserReport/GetMostSchaduleMinuteByPriceCategory");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetMostSchaduleCountByPriceCategory extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserReport/GetMostSchaduleCountByPriceCategory");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetMostSchaduleCountByMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserReport/GetMostSchaduleCountByMaster");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetMostSchaduleCountByDayOfWeek extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserReport/GetMostSchaduleCountByDayOfWeek");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}
class GetMostSchaduleCountByScheduleLoyaltyDiscount extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserReport/GetMostSchaduleCountByScheduleLoyaltyDiscount");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetUserByCreateDate extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserReport/UserByCreateDate");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetUsersByMinOneSchedule extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserReport/UserByMinOneSchadule");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  GetMostSchaduleMinuteByPriceCategory,
  GetMostSchaduleCountByPriceCategory,
  GetMostSchaduleCountByMaster,
  GetMostSchaduleCountByDayOfWeek,
  GetMostSchaduleCountByScheduleLoyaltyDiscount,
  GetUserByCreateDate,
  GetUsersByMinOneSchedule,
};
